<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.sheetEvent.menu"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.sheetEvent.list.title"></app-i18n>
      </h1>

      <app-sheet-event-list-toolbar></app-sheet-event-list-toolbar>
      <app-sheet-event-list-filter></app-sheet-event-list-filter>
      <app-sheet-event-list-table></app-sheet-event-list-table>
    </div>
  </div>
</template>

<script>
import SheetEventListFilter from '@modules/sheet-event/components/sheet-event-list-filter.vue';
import SheetEventListTable from '@modules/sheet-event/components/sheet-event-list-table.vue';
import SheetEventListToolbar from '@modules/sheet-event/components/sheet-event-list-toolbar.vue';

export default {
  name: 'app-sheet-event-list-page',

  components: {
    [SheetEventListFilter.name]: SheetEventListFilter,
    [SheetEventListTable.name]: SheetEventListTable,
    [SheetEventListToolbar.name]: SheetEventListToolbar,
  },
};
</script>

<style>
</style>
